import React, { useState, useEffect } from "react";
import HighchartsReact from "highcharts-react-official";
import HighchartsTreemap from "highcharts/modules/treemap";
import Highcharts from "highcharts";
import { Button } from "../..";
import {
  changeLog,
  EmissionGraphColors,
  emissionGraphHeading
} from "../../../util/constants";
import { useSelector, useDispatch } from "react-redux";
import { Log } from "../../../icons";
import { ChangeLog } from "./EmissionChangeLog";
import "../Emissions.scss";
import { LoadingIndicator } from "../../CommonUIComponents/LoadingIndicator/LoadingIndicator";

export function EmissionGraph({ loader }) {
  const reduceDefaultViewData = useSelector(
    (state) => state.project.defaultViewData
  );
  const isGraphSimulate = useSelector((state) => state.project.isGraphSimulate);
  const simulateGraphData = useSelector(
    (state) => state.project.simulateGraphData
  );
  const dispatch = useDispatch();
  HighchartsTreemap(Highcharts);
  const [chartOptions, setChartOptions] = useState({});
  const [changeLogModalOpen, setChangeLogModalOpen] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    if (reduceDefaultViewData?.graphData && !isGraphSimulate) {
      updateChartDataSet(reduceDefaultViewData?.graphData);
    }
    if (isGraphSimulate) {
      updateChartDataSet(simulateGraphData);
    }
  }, [reduceDefaultViewData, isGraphSimulate]);

  useEffect(() => {
    if (loader) {
      setShowLoader(true);
    } else {
      setShowLoader(false);
    }
  }, [loader]);

  const updateChartDataSet = (data) => {
    let graphDataArray = [];
    data?.map((item, i) => {
      graphDataArray.push({
        name: item.name?.split("[")[0]?.trimEnd(),
        value: item.value,
      });
    });
    setChartOptions({
      chart: {
        height: 600, // Set the desired height in pixels
      },
      plotOptions: {
        series: {
          borderWidth: 0,
        },
      },
      series: [
        {
          type: "treemap",
          layoutAlgorithm: "squarified",
          layoutStartingDirection: "horizantal",
          clip: false,
          data: graphDataArray,
          colorByPoint: true,
          colors: EmissionGraphColors,
        },
      ],
      title: {
        text: "",
      },
    });
  };
  return (
    <div className="emissions-graph-section">
      <div className="emissions-graph-title">
        <span>{emissionGraphHeading}</span>
        <Button
          onClick={() => setChangeLogModalOpen(true)}
          variant="text"
          className={"manage-emissions-body-upload-file-history-button"}
          data-testid="changeLog-button"
        >
          <Log />
          <span className="emissions-graph-title-log">{changeLog}</span>
        </Button>
      </div>
      <div className="emissions-graph-content" data-testid="loading-indicator">
        <LoadingIndicator show={showLoader} transparent fullscreen={false}>
          <HighchartsReact highcharts={Highcharts} options={chartOptions} />
        </LoadingIndicator>
      </div>
      {/* ChangeLog modal */}
      <ChangeLog
        isChangeLogOpen={changeLogModalOpen}
        onClose={() => {
          setChangeLogModalOpen(false);
        }}
      />
    </div>
  );
}
